export default "__VITE_ASSET__BGnq4$Zg__"